import React from 'react';
import { motion } from 'framer-motion';
export function ExtendedTestimonials() {
  const testimonials = [{
    initials: 'VM',
    name: 'Valentina M.',
    location: '4to año · Buenos Aires',
    message: 'Tenía parcial de Biomecánica en 3 días. Abrí el Tomo 1, ordené todo en una tarde y saqué un 8. Nunca estudié tan rápido.',
    time: '22:14',
    response: 'Ese es el objetivo 🙌 Que tengas todo claro y listo para estudiar.',
    responseTime: '22:14'
  }, {
    initials: 'RG',
    name: 'Rodrigo G.',
    location: '5to año · Mendoza',
    message: 'El Ebook del Manual Seguro me lo leí antes de mi primera guardia. Cuando el paciente se descompensó supe exactamente qué hacer. El residente me preguntó dónde había estudiado eso.',
    time: '21:45',
    response: 'Eso es lo que buscamos 💪 Criterio clínico real, no solo teoría.',
    responseTime: '21:46'
  }, {
    initials: 'CM',
    name: 'Camila M.',
    location: '3er año · Tucumán',
    message: 'Nunca entendí cómo se conectaba Biomecánica con la clínica. El Rescate lo explica con casos reales. Por fin la carrera tiene sentido para mí.',
    time: '20:30',
    response: 'Eso es exactamente lo que queríamos lograr con cada tomo 🎯',
    responseTime: '20:31'
  }];
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-116">
      <div className="max-w-5xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-119">
            Lo que dicen los estudiantes que ya lo usan:
          </h2>
          <p className="text-xl text-slate-600" data-id="element-120">
            +500 estudiantes de todo el país ya tienen la carrera organizada en
            un solo lugar.
          </p>
        </motion.div>

        <div className="space-y-8" data-id="element-121">
          {testimonials.map((testimonial, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="bg-slate-50 rounded-xl p-6 border border-slate-200" data-id="element-122">
              <div className="flex items-center gap-3 mb-4" data-id="element-123">
                <div className="w-12 h-12 bg-slate-300 rounded-full flex items-center justify-center font-bold text-slate-700" data-id="element-124">
                  {testimonial.initials}
                </div>
                <div data-id="element-125">
                  <p className="font-bold text-slate-900" data-id="element-126">{testimonial.name}</p>
                  <p className="text-sm text-slate-600" data-id="element-127">
                    {testimonial.location}
                  </p>
                </div>
              </div>

              <div className="space-y-4" data-id="element-128">
                <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-129">
                  <p className="text-slate-700 mb-2" data-id="element-130">{testimonial.message}</p>
                  <div className="flex justify-end items-center gap-2" data-id="element-131">
                    <span className="text-xs text-slate-500" data-id="element-132">
                      {testimonial.time}
                    </span>
                    <span className="text-blue-500 text-xs" data-id="element-133">✓✓</span>
                  </div>
                </div>

                <div className="bg-green-50 rounded-lg p-4 ml-8" data-id="element-134">
                  <p className="text-slate-700 mb-2" data-id="element-135">{testimonial.response}</p>
                  <div className="flex justify-start" data-id="element-136">
                    <span className="text-xs text-slate-500" data-id="element-137">
                      {testimonial.responseTime}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}